import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ModalService } from 'src/app/shared/services/modal.service';
import { ServiceProviderService } from 'src/app/shared/services/service-provider.service';
import { GenericServiceProvider } from '../../classes/generic-service-provider';
import { DynamicFormStructure } from '../../dynamic-form-structure';
import { SiteService } from 'src/app/shared/services/site.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent
  extends GenericServiceProvider
  implements OnInit, OnDestroy, AfterViewInit
{
  constructor(
    _siteService: SiteService,
    _modalService: ModalService,
    _messageService: MessageService,
    _serviceProviderService: ServiceProviderService
  ) {
    super(_siteService, _modalService, _messageService, _serviceProviderService);
  }

  ngOnInit(): void {
    const dynamicFormStructure = new DynamicFormStructure();

    super.ngOnInit(dynamicFormStructure.getNotificationStructure());
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
